import { __assign } from "tslib";
import * as React from 'react';
import { MultiCategorySelector } from './multi-category-selector.comp';
import { renderAndMountComponent } from '@wix/answers-lib';
import { getLegacyBaseDriverFromWrapper } from '../../../common/base-driver';
// tslint:disable-next-line:max-line-length
import { createMultiSelectLegacyDriver } from '../../../primitives/selectors/multi-select/multi-select.legacy-driver';
export var createMultiCategorySelectorDriver = function (wrapper) {
    var base = getLegacyBaseDriverFromWrapper(wrapper, '.multi-category-selector', MultiCategorySelector.name);
    return createMultiSelectLegacyDriver(base.elem);
};
export var renderMultiCategorySelectorAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(MultiCategorySelector, __assign({}, props)));
    return createMultiCategorySelectorDriver(elem);
};
//# sourceMappingURL=multi-category-selector.driver.js.map